import api from '@/services/api'

const updateUsersNetworks = async (
    users,
    update_leader,
    update_team,
    update_peers
) => {
    return await api.post('users/bulk/update-users-network', {
        users,
        update_leader,
        update_team,
        update_peers,
    })
}

export default updateUsersNetworks
